import FormLayout from '../../components/layouts/formPage/FormLayout';
import NewClubForm from '../../components/club/NewClubForm';

const NewClub = () => {
  return (
    <FormLayout title="new club">
      <NewClubForm />
    </FormLayout>
  );
};

export default NewClub;
